export default __webpack_public_path__ + "static/media/a bheil.85448555.mp3";